let language = {
    FOOTER_QPMN_COPYRIGHT: "Copyright",
    FOOTER_QPMN_MEMBER: "A member of QP Group",
    FOOTER_QPMN_TERMS: " Terms & Conditions",
    FOOTER_QPMN_POLICY: "Privacy Policy",
    FOOTER_QPSON_COPYRIGHT: "All Content Copyright",
    FOOTER_QPSON_COM: ".com (Part of QP Group)",
}

export { language }